<template>
  <div class="lt">

    <div class="lt-bottom">
      <div class="lt-bt-item" v-for="(item, index) in dataMap" :key="index">
        <img src="../../assets/template/l1-btimg.png" alt="" class="bt-bg-img" />
        <img src="../../assets/template/l1-icon.png" alt="" class="bt-icon" />
        <div class="lt-item-title">{{ item.name }}</div>
        <div class="lt-item-content">
          <div class="item-num" v-if="item.num1">{{ item.num1 }}</div>
          <div class="item-val" v-if="item.val && topMap.length">
            {{
              (item.val == "totalAmount"
                ? (select[item.val] / 10000).toFixed(2)
                : select[item.val]) || 0
            }}
          </div>
          <div class="item-unit" v-if="item.unit">{{ item.unit }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getHighway } from "../utils/request.js";

export default {
  name: 'template.leftTop',
  data() {
    return {
      //线路列表
      topMap: [],
      select: {},
      // 已选高速详情列表 name描述 val蓝色字体 unit白色字体
      dataMap: [
        { name: "今年累计销售额", val: "length", num1: '000', unit: "万元" },
        { name: "今年目标销售额", val: "investment", num1: '10000', unit: "万元" },
        { name: "累计客户数", val: "openDate", num1: '10000', unit: "个" },
        { name: "年度新增客户数", val: "stationNum", num1: '10000', unit: "个" },
        { name: "今年目标完成度", val: "totalAmount", num1: '10000', unit: "%" },
      ],
    };
  },
  watch: {},
  methods: {
    change(item) {
      // if (item.id == this.select.id) return;
      // this.select = item;
      // this.$emit('roadselect', item)
    },
    setloadreal() {
      // const dalong = this.topMap.find((item) => item.id == 1005);
      // this.change(dalong);
    },
  },
  mounted() {
    // getHighway().then(res => {
    // 	this.topMap = res.data
    // 	this.change(this.topMap[0])
    // })
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 480px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.lt-top {
  width: 480px;
  height: 240px;
  background: #000;
  // margin: 16px 0 8px 35px;
  // margin: 26px 0 18px 35px;
  background: #071426;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.lt-top-item {
  position: absolute;
  /* line-height: 31px; */
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  position: relative;
  cursor: pointer;
  pointer-events: auto;
}

.item-text {
  overflow: hidden;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  z-index: 2;
  padding: 6px 10px;
}

/* .lt-top-item span {
	z-index: 2;
	position: relative;
} */
.active {
  border: 1px solid #00638e;
  position: absolute;
  background: linear-gradient(to top, #004e8a, #001f3e);
  /* background: url(../assets/gsicon/item-bg.png) no-repeat; */
  width: 100%;
  height: 100%;
  border-radius: 5px;
  z-index: 1;
}

.lt-bottom {
  margin: 0px 0 6px ;
  height: 240px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-left: -20px;
}

.lt-bt-item {
  width: 194px;
  height: 114px;
  position: relative;
  margin-left: -54px;
}

.lt-bt-item:nth-child(3n + 1) {
  margin-left: 0;
}

.bt-bg-img {
  position: absolute;
  width: 194px;
  height: 114px;
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 20px;
}

.lt-item-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #afc2df;
  line-height: 19px;
  position: absolute;
  top: 26px;
  left: 61px;
}

.lt-item-content {
  display: flex;
  position: absolute;
  top: 72px;
  left: 44px;
}

.item-num {
  font-family: Benmo-Ziyu;
  font-weight: 400;
  font-size: 22px;
  color: #3fc5ff;
  line-height: 19px;

}

.item-val {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #AFC2DF;
  line-height: 19px;
}

.item-unit {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a6bbd9;
  line-height: 19px;
  margin-left: 4px;
}
</style>